import React from "react";

function Resultado({ imc }) {
  let mensagem = "";
  let cor = "";

  if (imc < 18.5) {
    mensagem = "😟 Abaixo do peso";
    cor = "orange";
  } else if (imc < 24.9) {
    mensagem = "🙂 Peso normal";
    cor = "green";
  } else if (imc < 29.9) {
    mensagem = "🙂 Sobrepeso";
    cor = "purple";
  } else {
    mensagem = "😰 Obesidade";
    cor = "red";
  }

  return (
    <div className="resultado animacao" style={{ backgroundColor: cor }}>
      <h2>Seu IMC: {imc}</h2>
      <p>{mensagem}</p>
    </div>
  );
}

export default Resultado;